import { render } from "./VerifyCertificate.vue?vue&type=template&id=7d2a88f6"
import script from "./VerifyCertificate.vue?vue&type=script&lang=js"
export * from "./VerifyCertificate.vue?vue&type=script&lang=js"

import "./VerifyCertificate.vue?vue&type=style&index=0&id=7d2a88f6&lang=css"

import exportComponent from "D:\\a\\1\\s\\eNotary.SPA\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__